<p *ngIf="hasMissingValue && finishedAndLocked">
	<i-feather name="check" class="icon"></i-feather>
	{{ _element.title }}
</p>
<p *ngIf="hasMissingValue && !finishedAndLocked" (click)="toggleMissingValueInMenu();" class="clickable">
	<i-feather name="x" class="icon"></i-feather>
	{{ 'word.missing_value_remove_with_title' | translate: {missing_value: _element.title} }}
</p>
<p *ngIf="!hasMissingValue && !finishedAndLocked" (click)="toggleMissingValueInMenu();" class="clickable">
	<i-feather name="plus" class="icon"></i-feather>
	{{ 'word.missing_value_use_with_title' | translate: {missing_value: _element.title} }}
</p>

<workflow-missing-value-modal *ngIf="showMissingValueModal"
		(clickOk)="enableMissingValue()"
		[(showMissingValueModal)]="showMissingValueModal"
></workflow-missing-value-modal>
